export const createUser = (value, avatar) => {
    console.log("createUser called with value:", value);
    return Promise.resolve();
};

export const deletedUser = (userId) => {
    console.log("deletedUser called with userId:", userId);
    return Promise.resolve();
};

export const editUser = (value, url, userId) => {
    console.log("editUser called with value:", value);
    return Promise.resolve();
};


export const getAge = (min, max) => {
    console.log("getAge called with min:", min, "max:", max);
    return Promise.resolve();
};